export default __webpack_public_path__ + "static/bn-ad7aafa9a29894397b43296e034a46ee.svg";